import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=395d1be0&scoped=true&external"
import script from "./MoorageOrder.vue?vue&type=script&lang=js"
export * from "./MoorageOrder.vue?vue&type=script&lang=js"
import style0 from "./MoorageOrder.vue?vue&type=style&index=0&id=395d1be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d1be0",
  null
  
)

export default component.exports